import { apiQueryWithToken } from "../../common/services/apiBaseUrlConfig";

const FEEDBACK_ENDPOINT = "/api/feedback/share";

const interpretMessage = (body) => {
  if (typeof body === "string") return body;
  if (body && typeof body === "object") return body.message || body.result || "";
  return "";
};

async function submitFeedback(payload) {
  try {
    const response = await apiQueryWithToken.post(FEEDBACK_ENDPOINT, payload);
    const message = interpretMessage(response?.data);
    if (!/success|received/i.test(String(message))) {
      throw new Error(String(message) || "Feedback Cannot be Recorded");
    }
    return String(message);
  } catch (error) {
    const responseMessage = interpretMessage(error?.response?.data);
    if (responseMessage) throw new Error(responseMessage);
    throw error;
  }
}

export { submitFeedback, FEEDBACK_ENDPOINT };
